import { SelectInput, type SelectOption } from "@SeemplicityDev/shared";
import React, { type FC, type ReactNode } from "react";

export interface CreateTicketSelectOption {
  value?: string;
  label?: ReactNode;
  [key: string]: unknown;
}

export interface CreateTicketSelectProps {
  onChange: (value: string) => void;
  ticketManagerOptions?: CreateTicketSelectOption[];
  selectedTicketManager?: string | null;
  disabled?: boolean;
  noMargin?: boolean;
  label?: ReactNode;
  setDefaultSingleOption?: boolean;
  readOnly?: boolean;
  "data-analytics-event"?: string;
  "data-analytics-props"?: string;
}

const CreateTicketSelect: FC<CreateTicketSelectProps> = ({
  onChange,
  ticketManagerOptions,
  selectedTicketManager,
  disabled,
  noMargin,
  label = null,
  setDefaultSingleOption = false,
  readOnly,
  "data-analytics-event": analyticsEvent,
  "data-analytics-props": analyticsProps,
}) => {
  return (
    <SelectInput
      data-testid={"create-ticket-dropdown"}
      name={`ticket`}
      disabled={disabled}
      menuWrapClassName="status-menu"
      onChange={(selectedValue: CreateTicketSelectOption) => {
        // SelectInput's value field is loosely typed; cast to the string
        // contract CreateTicketSelect's onChange exposes to consumers.
        onChange(selectedValue.value as string);
      }}
      // CreateTicketSelectOption.label is ReactNode; SelectInput's SelectOption
      // narrows to string. Runtime labels are strings.
      options={ticketManagerOptions as SelectOption[] | undefined}
      value={
        (ticketManagerOptions?.find(
          (ticketManager) => ticketManager?.value === selectedTicketManager
        ) || { label: "Create Ticket", value: "" }) as SelectOption
      }
      label={label as string | undefined}
      labelTop
      setDefaultSingleOption={setDefaultSingleOption}
      noMargin={noMargin}
      readOnly={readOnly}
      data-analytics-event={analyticsEvent}
      data-analytics-props={analyticsProps}
    />
  );
};

export default CreateTicketSelect;
